import Inicio from "@pages/Inicio/Inicio";

export default Inicio;
